import {
  TextField,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
} from '@mui/material';
import Button from '../atoms/Button';
import PageHeader from '../molecules/PageHeader';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const UpdateDetailsLayout = ({
  studentData,
  detailsToUpdate,
  handleFormUpdate,
  formSubmit,
  loading,
  setLoading,
}) => {
  return (
    <div>
      <PageHeader>
        Update Details for {studentData?.student?.student_first_name}{' '}
        {studentData?.student?.student_last_name}
      </PageHeader>
      <TextField
        label='Mobile Number'
        fullWidth
        name='student_mobile'
        value={detailsToUpdate?.student_mobile ?? ''}
        onChange={handleFormUpdate}
        // inputProps={{ 'data-cy': 'id-number-field' }}
      />
      <div className='spacer'></div>
      <TextField
        label='School in 2026'
        fullWidth
        name='student_school'
        value={detailsToUpdate?.student_school ?? ''}
        onChange={handleFormUpdate}
        // inputProps={{ 'data-cy': 'id-number-field' }}
      />
      <div className='spacer'></div>
      <TextField
        select
        label='School Level in 2026'
        fullWidth
        name='student_school_level'
        value={detailsToUpdate?.student_school_level ?? ''}
        onChange={handleFormUpdate}
      >
        <MenuItem value='Primary 1'>Pri 1</MenuItem>
        <MenuItem value='Primary 2'>Pri 2</MenuItem>
        <MenuItem value='Primary 3'>Pri 3</MenuItem>
        <MenuItem value='Primary 4'>Pri 4</MenuItem>
        <MenuItem value='Primary 5'>Pri 5</MenuItem>
        <MenuItem value='Primary 6'>Pri 6</MenuItem>
        <MenuItem value='Secondary 1'>Sec 1</MenuItem>
        <MenuItem value='Secondary 2'>Sec 2</MenuItem>
        <MenuItem value='Secondary 3'>Sec 3</MenuItem>
        <MenuItem value='Secondary 4'>Sec 4</MenuItem>
      </TextField>

      <div className='spacer'></div>
      <TextField
        label='Email'
        fullWidth
        name='student_email'
        value={detailsToUpdate?.student_email ?? ''}
        onChange={handleFormUpdate}
        // inputProps={{ 'data-cy': 'id-number-field' }}
      />
      <div className='spacer'></div>
      <TextField
        label='Postal Code'
        fullWidth
        name='student_address_postal'
        value={detailsToUpdate?.student_address_postal ?? ''}
        onChange={handleFormUpdate}
        // inputProps={{ 'data-cy': 'id-number-field' }}
      />
      <div className='bigSpacer'></div>
      <div>
        <span className='bold'>Session Time:</span>{' '}
        {studentData?.student.session ?? (
          <span className='text-gray-400'>Not assigned yet</span>
        )}
        <div className='py-2 text-sm'>
          If you would like to request for a change in session timing in 2025,
          pick the new timing below.
          <br /> (Subject to availability and confirmation from the Catechetical
          Office.)
        </div>
        <FormControl sx={{ m: 1, minWidth: 300 }} size='small'>
          <TextField
            label='Preferred Session'
            name='student_preferred_session_time'
            onChange={handleFormUpdate}
            value={detailsToUpdate?.student_preferred_session_time ?? ''}
            select
          >
            <MenuItem value=''>&nbsp;</MenuItem>
            <MenuItem key='1' value='1'>
              Saturday, 2:45pm
            </MenuItem>
            <MenuItem key='2' value='2'>
              Saturday, 4:45pm
            </MenuItem>
            <MenuItem key='3' value='3'>
              Sunday 8:45am
            </MenuItem>
            <MenuItem key='4' value='4'>
              Sunday 10:30am
            </MenuItem>
          </TextField>
        </FormControl>
      </div>

      <div className='spacer'></div>
      <div>
        <Button callback={formSubmit} loading={loading}>
          Confirm
        </Button>
      </div>
      <ToastContainer />
    </div>
  );
};

export default UpdateDetailsLayout;
